import React from "react";
import { getMeetingBookingUrl, getOrg } from "../../../utils/site";
import { contactPageData } from "./data";
import { i18n } from "next-i18next";

const getContactPageStructuredData = (slug?: string) => {
  const org = getOrg();

  switch (org) {
    case "swe":
      if (slug === "sv/kontakta-oss") {
        return contactPageData["sv-SE"];
      }
      if (slug === "en/kontakta-oss") {
        return contactPageData["en-SE"];
      }
      break;
    case "ger":
      if (slug === "de/kontaktmoeglichkeiten") {
        return contactPageData["de-DE"];
      }
      if (slug === "en/contact-us") {
        return contactPageData["en-DE"];
      }
      break;
    case "fra":
      if (slug === "fr/contactez-nous") {
        return contactPageData["fr-FR"];
      }
      if (slug === "en/contact-us") {
        return contactPageData["en-FR"];
      }
      break;
    default:
      return null;
  }
};

type ContactPageStructuredDataProps = {
  url: string;
  slug?: string;
};

export const ContactPageStructuredData = ({
  url,
  slug,
}: ContactPageStructuredDataProps) => {
  const data = getContactPageStructuredData(`${i18n?.language}/${slug}`);

  if (!data) {
    return null;
  }

  const bookingUrl = getMeetingBookingUrl();

  // Add the @id and url to the structured data
  const structuredData = {
    ...data,
    "@id": url,
    url: url,
    ...(bookingUrl && {
      potentialAction: {
        "@type": "ScheduleAction",
        target: bookingUrl,
      },
    }),
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
    />
  );
};
